import { createApp } from 'vue'
import RegisterApp from './RegisterApp.vue'
import { initAuthTheme } from '../shared/composables/useAuthTheme.js'
import { FLOWS } from './constants/steps.js'

const mount = document.getElementById('register-app')

if (mount) {
  initAuthTheme()

  let salutations = []
  let genders = []
  try {
    salutations = JSON.parse(mount.dataset.salutations ?? '[]')
  } catch {
    salutations = []
  }
  try {
    genders = JSON.parse(mount.dataset.genders ?? '[]')
  } catch {
    genders = []
  }

  createApp(RegisterApp, {
    config: {
      flow:                 mount.dataset.flow ?? FLOWS.CHOOSE,
      initialCode:          mount.dataset.initialCode ?? '',
      initialCompanyName:   mount.dataset.initialCompanyName ?? '',
      initialReferralError: mount.dataset.initialReferralError ?? '',
      salutations,
      genders,
      termsLink:            mount.dataset.termsLink ?? '',
      privacyLink:          mount.dataset.privacyLink ?? '',
      consentLink:          mount.dataset.consentLink ?? '',
      loginUrl:             mount.dataset.loginUrl ?? '/login',
      practiceUrl:          mount.dataset.practiceUrl ?? '/register-practice',
      patientUrl:           mount.dataset.patientUrl ?? '/register-patient',
      supportPhone:         mount.dataset.supportPhone ?? '815-908-2020',
      showVideo:            mount.dataset.showVideo === '1' || mount.dataset.showVideo === 'true',
      videoUrl:             mount.dataset.videoUrl ?? '',
      videoTitle:           mount.dataset.videoTitle ?? '',
      videoPoster:          mount.dataset.videoPoster ?? '',
      mapsApiKey:           mount.dataset.mapsApiKey ?? '',
      googlePlacesEnabled:  false,
      npiSearchLink:        mount.dataset.npiSearchLink ?? 'https://npiregistry.cms.hhs.gov/search',
      brandLogoUrl:         mount.dataset.brandLogo ?? document.body.dataset.brandLogo ?? '',
      canResume:            mount.dataset.canResume === 'true',
      classicPatientRegistration: mount.dataset.classicPatientRegistration === 'true',
      flowMode:             mount.dataset.flowMode ?? 'modern',
    },
  }).mount(mount)
}
